import { ApmBase } from '@elastic/apm-rum';
import { getExtraContextByInpValue, init as initExtraInpContextCapture } from './extra-inp-context';
import { getExtraLcpContext, init as initExtraLcpContextCapture } from './extra-lcp-context';
import { extendTransactionWindowForBetterLCPReporting } from './extend-transaction';
import { type ExtendedTransaction } from './types';
import { normalisePagePath, normaliseApiPath } from './url-parser';

const extendInstrumentation = (apm: ApmBase) => {
  apm.observe('transaction:end', (transaction: ExtendedTransaction) => {
    if (transaction?.context?.tags?.inp_value) {
      transaction.addLabels(getExtraContextByInpValue(transaction.context.tags.inp_value));
    }
    if (transaction?.marks?.agent?.largestContentfulPaint) {
      transaction.addLabels(getExtraLcpContext());
    }

    // Add custom label for API requests
    if (transaction?.type === 'http-request') {
      transaction.addLabels({
        normalised_api_path: normaliseApiPath(transaction.name),
      });
    }

    apm.addLabels({
      urlPath: normalisePagePath(window.location.pathname),
    });
  });

  extendTransactionWindowForBetterLCPReporting(apm);
  initExtraInpContextCapture();
  initExtraLcpContextCapture();

  return apm;
};

export default extendInstrumentation;
